import React, { useState, useRef, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import axios from "axios";
import { useYearContext } from "../components/YearContext";

function Employeestatus() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [employeeData, setEmployeeData] = useState([]);

  const fetchEmployeeData = async () => {
    try {
      const response = await axios.get(
        "https://api.easytaxexperts.com/api/getemployeestat"
      );
      setEmployeeData(response.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, []);

  const [clientdetails, setClientdetails] = useState([]);

  const fetchClients = async () => {
    if (!selectedEmp) {
      setClientdetails([]);
      return;
    }

    try {
      const response = await axios.post(
        "https://api.easytaxexperts.com/fetchempclients",
        { selectedEmp }
      );

      if (response.data.success) {
        setClientdetails(response.data.result);
      } else {
        setClientdetails([]);
      }
    } catch (error) {
      console.log(error);
      setClientdetails([]);
    }
  };

  const [selectedEmp, setselectedEmp] = useState("");

  const handleItemClick = (username) => {
    setselectedEmp(username);
  };

   //pagination
   const [currentPage, setCurrentPage] = useState(1);
   const recordsPerPage = 100;
   const lastIndex = currentPage * recordsPerPage;
   const firstIndex = lastIndex - recordsPerPage;
   const records = clientdetails.slice(firstIndex, lastIndex);
   const npage = Math.ceil(clientdetails.length / recordsPerPage);
   const numbers = [...Array(npage + 1).keys()].slice(1);
 
   const prePage = () => {
     if (currentPage !== 1) {
       setCurrentPage(currentPage - 1);
     }
   };
   const changeCpage = (id) => {
     setCurrentPage(id);
   };
   const nextPage = () => {
     if (currentPage !== npage) {
       setCurrentPage(currentPage + 1);
     }
   };
 

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div className="mt-3 d-flex gap-2 justify-content-center">
              <div className="col-lg-4">
                <div className="dropdown">
                  <input
                    className="form-control dropdown-toggle"
                    data-bs-toggle="dropdown"
                    name="empname"
                    value={selectedEmp}
                    onChange={(e) => setselectedEmp(e.target.value)}
                  />

                  <ul className="dropdown-menu employeeul" >
                    {employeeData
                      .filter((emp) =>
                        emp.username
                          .toLowerCase()
                          .includes(selectedEmp.toLowerCase())
                      )
                      .map((emp) => (
                        <li
                          className="dropdown-item"
                          key={emp.username}
                          onClick={() => handleItemClick(emp.username)}
                        >
                          {emp.username}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={fetchClients}
              >
                Search
              </button>
            </div>
            <div className="table-responsive mt-4">
              <table className="table table-bordered table-hover">
                <thead className="table-primary">
                  <tr>
                    <th>S.No</th>
                    <th>Client ID</th>
                    <th>Client Name</th>
                    <th>Email</th>
                    <th>Contact No</th>
                    <th>Status</th>
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {clientdetails.length > 0 ? (
                    records.map((each, index) => (
                      <tr key={each.id}>
                        <td>{index + 1}</td>
                        <td>{each.client_id}</td>
                        <td>{each.client_name}</td>
                        <td>{each.email}</td>
                        <td>{each.contact}</td>
                        <td>{each.status}</td>
                        <td>{each.comments}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <nav className="mt-2">
  <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
    <li className="page-item">
      <a
        href="#"
        className="page-link"
        onClick={prePage}
        style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }}
      >
        Prev
      </a>
    </li>
    {numbers.map((n, i) => {
      return (
        <li
          className={`page-item ${
            currentPage === n ? "active" : ""
          }`}
          key={i}
        >
          <a
            href="#"
            className="page-link"
            onClick={() => changeCpage(n)}
            style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
          >
            {n}
          </a>
        </li>
      );
    })}
    <li className="page-item">
      <a
        href="#"
        className="page-link"
        onClick={nextPage}
        style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}
      >
        Next
      </a>
    </li>
  </ul>
</nav>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Employeestatus;
